<template lang="">
    <img :alt="$t('popupCard.addCard.photoExample')" class="w-max rounded-md" src="../../../assets/card.jpg" />
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
</style>
